var map = {
	"./blank_card.png": "9598",
	"./blank_card_mastercard.png": "6f25",
	"./credit.svg": "84f2",
	"./debit.svg": "05bc",
	"./empty-transactions.svg": "8f2e",
	"./home.svg": "9ce9",
	"./info.svg": "fd38",
	"./lock.svg": "f108",
	"./logout.svg": "6451",
	"./settings.svg": "7742",
	"./transactions.svg": "761f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "291e";